import { render, staticRenderFns } from "./CountDownEscassez.vue?vue&type=template&id=79373ae2&scoped=true"
import script from "./CountDownEscassez.vue?vue&type=script&lang=js"
export * from "./CountDownEscassez.vue?vue&type=script&lang=js"
import style0 from "./CountDownEscassez.vue?vue&type=style&index=0&id=79373ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79373ae2",
  null
  
)

export default component.exports